import { Identity } from 'embedded/api/out/Identity';
import { ValidationErrorResult } from 'utils/jsonValidation/AjvValidator';

export type ReceivedMessageStatus =
    | 'Received'
    | 'Processing'
    | 'Success'
    | 'Error';
export type ReceiveMessageErrorStatus =
    | 'Validation Failed'
    | 'Invalid Topic'
    | 'Processing Failed'
    | 'Not Authenticated'
    | 'Invalid App Mode';

export type SendMessageStatus = 'Error' | 'Success';
export type SendMessageErrorStatus =
    | 'Invalid Topic'
    | 'Invalid Identity'
    | 'Message Sent'
    | 'Exception from subscriber';

export interface ReceivedMessageState<TMessagePayload> {
    seq: number;
    uid: string;
    topic: string;
    status: ReceivedMessageStatus;
    payload: TMessagePayload;
    receivedTime: Date;
    updatedTime: Date;
    errorStatus?: ReceiveMessageErrorStatus;
    validationError?: ValidationErrorResult;
    error?: Error;
}

export interface ReceivedMessagesState {
    [topic: string]: ReceivedMessageState<unknown>[];
}

export interface SentMessageState<TPayload> {
    seq: number;
    identity: Identity;
    topic: string;
    status: SendMessageStatus;
    errorStatus?: SendMessageErrorStatus;
    message?: TPayload;
    time: Date;
    error?: Error;
}

export interface SentMessagesState {
    [topic: string]: SentMessageState<unknown>[];
}

export interface EmbeddedApiState {
    nextSeq: number;
    receivedMessages: ReceivedMessagesState;
    sentMessages: SentMessagesState;
}

export const initialEmbeddedApiState: EmbeddedApiState = {
    nextSeq: 0,
    receivedMessages: {},
    sentMessages: {},
};
